// @flow

import type {
  CartCouponSuggestion,
  CartCouponSuggestionAPI,
  CartProductSuggestion,
  CartProductSuggestionAPI,
} from './types';

export const REFER_A_FRIEND_REASON = 'refer_a_friend_shs_offer';

export function stringify(params: { ... }): string {
  return Object.keys(params).reduce((acc, param) => {
    if (params[param] === undefined) return acc;
    return `${acc}${acc ? '&' : '?'}${param}=${encodeURIComponent(
      String(params[param]),
    )}`;
  }, '');
}

export const formatSuggestion: (
  suggestion: CartProductSuggestionAPI,
) => CartProductSuggestion = suggestion => {
  const { payload, process, product_type, subtype, reason, reason_label } =
    suggestion;

  const { currency, grid, taxes, products = [] } = suggestion.prices;

  const product = products.filter(prod => prod.process === process)[0];
  const name = product?.name;

  const prices = product.prices.slice();
  prices.sort((a, b) => {
    if (a.min_duration < b.min_duration) return -1;
    if (a.min_duration > b.min_duration) return 1;

    if (a.price_after_taxes < b.price_after_taxes) return -1;
    if (a.price_after_taxes > b.price_after_taxes) return 1;

    return 0;
  });

  let discount;
  const code = suggestion.discount?.code;
  const related_product = suggestion.discount?.related_product;
  if (code) {
    discount = {
      code,
      related_product,
    };
  }

  const price = prices[0];

  return {
    type: 'suggest',
    name,
    reason,
    reason_label,
    subtype,
    process,
    product_type,
    payload,
    discount,
    price: {
      grid,
      taxes,
      currency,
      discount: !!price.discount,
      min_duration: price.min_duration,
      max_duration: price.max_duration,
      duration_unit: price.duration_unit,
      price_before_taxes: price.price_before_taxes,
      price_after_taxes: price.price_after_taxes,
      normal_price_before_taxes: price.normal_price_before_taxes,
      normal_price_after_taxes: price.normal_price_after_taxes,
    },
  };
};

export function formatCoupon(
  suggestion: CartCouponSuggestionAPI,
): CartCouponSuggestion {
  const { discount } = suggestion;

  return {
    type: 'coupon',
    reason: suggestion.reason,
    reason_label: suggestion.reason_label,
    discount,
  };
}
